import React, {Fragment} from 'react';
import { Dialog, Transition } from '@headlessui/react';
const InvalidTokenDialog = ({ open, handleClose }) => {
  return (
    <Transition.Root show={true} as={Fragment}>
       <Dialog as="div" className="relative z-10" onClose={() => null}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>
        
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                  <div>
                    <div className="text-center">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-medium leading-6 text-gray-900"></Dialog.Title>
                      <div className="mt-2 justify-center grid grid-cols-1">
                        <div className="sm:col-span-1">
                          <h2 className="text-2xl font-bold text-gray-900">Token is already used</h2>
                        </div>
                        <div className="sm:col-span-1 mt-2">
                          <h2 className="text-lg font-bold text-gray-900">If you still do not have an active subscription, you can request a new token</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
          </div>
        </div>

       </Dialog>
    </Transition.Root>
   
  );
};

export default InvalidTokenDialog;